import { createBrowserRouter, redirect } from "react-router-dom";
import { AuthLayout, MainLayout } from "../Layout";

import { store } from "../Store/store";
import {
  AboutUs,
  Home,
  NotFound,
  Cooperation,
  Gyms,
  Coaches,
  CoachDetails,
  Adv,
  CooperationDetails,
  Blogs,
  BlogDetails,
  GymDetails,
  Auth,
  Error,
} from "../Pages/Main";

export const tokenProtector = () => {
  const token = store.getState().userSlice.token;

  // const navigate=useNavigate()
  if (!token) {
    return redirect("/auth");
    // navigate("/")
  }

  return null;
};
export const authProtector = () => {
  const token = store.getState().userSlice.token;

  // const navigate=useNavigate()
  if (token) {
    return redirect("/");
    // navigate("/")
  }

  return null;
};

const router = createBrowserRouter([
  {
    path: "",
    element: <MainLayout />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about-us",
        element: <AboutUs />,
      },
      {
        path: "gyms",
        element: <Gyms />,
      },
      {
        path: "gyms/:id",
        element: <GymDetails />,
      },
      {
        path: "gyms/:id/:name",
        element: <GymDetails />,
      },
      {
        path: "coaches",
        element: <Coaches />,
      },
      {
        path: "coaches/:id",
        element: <CoachDetails />,
      },
      {
        path: "coaches/:id/:name",
        element: <CoachDetails />,
      },
      {
        path: "adv",
        element: <Adv />,
      },
      {
        path: "cooperation",
        element: <Cooperation />,
      },
      {
        path: "cooperation/:id",
        element: <CooperationDetails />,
      },
      {
        path: "blogs",
        element: <Blogs />,
      },
      {
        path: "blogs/:id",
        element: <BlogDetails />,
      },
    ],
  },
  {
    path: "/auth",
    element: <Auth />,
    loader: authProtector,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "error",
    element: <Error />,
  },
]);
export default router;
